import { ProfileInfo } from '@barthauer/basys/core/authentication';
import { ConvertHelper } from '../helpers';

export class ProfileCommand {
  dataMode: string;
  inputType: string;
  name: string;
  type: string;
  windowType: string;
  visibility: string;
  ConfigurationGroups: ConfigurationGroupDefinition[];

  constructor(obj?: any) {
    if (obj) {
      Object.assign(this, obj);

      this.ConfigurationGroups = [];
      if (obj.ConfigurationGroups) {
        for (const group of obj.ConfigurationGroups) {
          this.ConfigurationGroups.push(new ConfigurationGroupDefinition(group));
        }
      }
    }
  }
}

export class ConfigurationGroupDefinition {
  specialType: string;
  allowCustomDocuments: boolean;
  Documents: DefinitionDocumentReference[];

  constructor(obj?: any) {
    if (obj) {
      Object.assign(this, obj);
      if (this.allowCustomDocuments) {
        this.allowCustomDocuments = ConvertHelper.toBoolean(this.allowCustomDocuments);
      }
      this.Documents = [];
      if (obj.Documents) {
        for (const document of obj.Documents) {
          this.Documents.push(new DefinitionDocumentReference(document));
        }
      }
    }
  }
}

export class DefinitionDocumentReference {
  id: string;
  name: string;
  constructor(data: any) {
    Object.assign(this, data);
  }
}

export class ProfileInfoViewModel {
  private _settings: ProfileSettingsViewModel;
  get id(): string {
    return this.profileInfo.id;
  }
  get displayText(): string {
    return this.profileInfo.displayText;
  }
  get isCurrent(): boolean {
    return this.profileInfo.isCurrent ?? false;
  }
  get settings(): ProfileSettingsViewModel {
    return this._settings;
  }
  get mapImagePreview(): string {
    return this.profileInfo.mapImagePreview;
  }
  get description(): string {
    return this.profileInfo.description;
  }
  constructor(
    private profileInfo: ProfileInfo,
    settings?: ProfileSettingsViewModel
  ) {
    if (settings) {
      this._settings = settings;
    } else if (profileInfo.settings) {
      this._settings = new ProfileSettingsViewModel(profileInfo.settings);
    }
  }
}
export class ProfileSettingsViewModel {
  private _commands: ProfileCommandViewModel[];
  get commands(): ProfileCommandViewModel[] {
    return this._commands;
  }
  public hasVisibleCommand(name: string): boolean {
    return this.commands.some((c) => c.name === name && c.visibility === ProfileCommandVisibility.AlwaysVisible);
  }

  public findSpecialCommandDocuments(specialType: 'Arena' | 'GisReport'): DefinitionDocumentReference[] | undefined {
    for (const command of this.commands) {
      if (command.visibility !== ProfileCommandVisibility.AlwaysHidden && command.definition?.ConfigurationGroups) {
        for (const group of command.definition?.ConfigurationGroups) {
          if (group.specialType === specialType) {
            return group.Documents;
          }
        }
      }
    }
    return undefined;
  }

  public findSpecialQueryCommandDocuments(commandName: string): DefinitionDocumentReference[] {
    return this.findCommandDocuments(commandName, 'Query')?.documents;
  }

  public findSpecialReportCommandDocuments(commandName: string): DefinitionDocumentReference[] {
    return this.findCommandDocuments(commandName, 'Report')?.documents;
  }

  public findCommandDocuments(
    commandName: string,
    groupName: 'Query' | 'Report' | 'Settings' | 'Configuration'
  ): { allowCustomDocuments: boolean; documents: DefinitionDocumentReference[] } {
    let allowCustom: boolean | undefined = false;
    const ret: DefinitionDocumentReference[] = [];
    for (const command of this.commands) {
      if (
        command.visibility !== ProfileCommandVisibility.AlwaysHidden &&
        command.definition?.ConfigurationGroups &&
        command.name === commandName
      ) {
        allowCustom = undefined;
        for (const group of command.definition?.ConfigurationGroups) {
          if (group['name'] === groupName) {
            allowCustom = group.allowCustomDocuments;
            for (const d of group.Documents) {
              ret.push(d);
            }
          }
        }
      }
    }

    return { allowCustomDocuments: allowCustom ?? true, documents: ret };
  }

  constructor(settings: any) {
    this._commands = new Array<ProfileCommandViewModel>();

    if (settings.Commands) {
      for (const command of settings.Commands) {
        this._commands.push(new ProfileCommandViewModel(new ProfileCommand(command)));
      }
    }
  }
}

export class ProfileCommandViewModel {
  get dataMode(): string {
    return this.profileCommand.dataMode;
  }
  get inputType(): string {
    return this.profileCommand.inputType;
  }
  get name(): string {
    return this.profileCommand.name;
  }
  get type(): string {
    return this.profileCommand.type;
  }
  get windowType(): string {
    return this.profileCommand.windowType;
  }
  get visibility(): ProfileCommandVisibility {
    let ret: ProfileCommandVisibility = ProfileCommandVisibility.AlwaysVisible;
    switch (this.profileCommand.visibility) {
      case 'AlwaysVisible':
        ret = ProfileCommandVisibility.AlwaysVisible;
        break;
      case 'AlwaysHidden':
        ret = ProfileCommandVisibility.AlwaysHidden;
        break;
    }
    return ret;
  }

  get definition(): ProfileCommand {
    return this.profileCommand;
  }

  constructor(private profileCommand: ProfileCommand) {}
}

export enum ProfileCommandVisibility {
  AlwaysVisible = 1,
  AlwaysHidden,
}
